import styled from '@emotion/styled';
import * as React from 'react';
import { Spacings } from '@styles/index';
import H6 from '@base/H6/H6';
import Dynamic from '@base/Dynamic/Dynamic';
import { keyframes } from '@emotion/react';

const KeyboardArrowDown = Dynamic(() => import('@icon/KeyboardArrowDown'));

const keyFrameOpen = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

interface H6Props {
  $isVisible: boolean;
}

interface KeyboardArrowDownProps {
  $transform: boolean;
  size: string;
  fill: string;
}

interface IShowMoreWrapperProps {
  showAllUsers: boolean;
  onClickShowButton: () => void;
}

const Wrapper = styled.div`
  margin-top: ${Spacings.SPACING_6B};
  width: 100%;
`;

const InnerWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyH6 = styled(H6)<H6Props>`
  line-height: 18px;
  margin-right: ${Spacings.SPACING_2};
  height: ${Spacings.SPACING_5B};
  animation-name: ${keyFrameOpen};
  animation-duration: 300ms;
  opacity: ${({ $isVisible }) => ($isVisible ? '1' : '0')};
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
`;

const StyKeyboardArrowDown = styled(KeyboardArrowDown)<KeyboardArrowDownProps>`
  transform: ${({ $transform }) => ($transform ? 'rotate(180deg)' : 'none')};
`;

const ShowMoreWrapper: React.FC<IShowMoreWrapperProps> = ({
  showAllUsers,
  onClickShowButton
}) => {
  return (
    <Wrapper>
      <InnerWrapper onClick={onClickShowButton}>
        <StyH6 color="var(--color-base-fill)" $isVisible={!showAllUsers}>
          Show more
        </StyH6>
        <StyH6 color="var(--color-base-fill)" $isVisible={showAllUsers}>
          Show less
        </StyH6>
        <StyKeyboardArrowDown
          size={Spacings.SPACING_5B}
          fill="var(--color-base-fill)"
          $transform={showAllUsers}
        />
      </InnerWrapper>
    </Wrapper>
  );
};

export default ShowMoreWrapper;
